import {
	selectedHealingAtom,
	removeHealingItem,
	healingAiTemporaryItemAtom,
	clearAiHealingCandidate,
} from "@/store/editor/healing-state"
import { ContextMenuSeparator } from "@radix-ui/react-context-menu"
import { useAtomValue } from "jotai"
import { PropsWithChildren } from "react"
import { useTranslation } from "react-i18next"
import { ContextMenuItem } from "../ui/ContextMenu"

export const HealingContextMenu = (_: PropsWithChildren) => {
	const { t } = useTranslation("components")
	const selectedHealing = useAtomValue(selectedHealingAtom)
	const temporaryItem = useAtomValue(healingAiTemporaryItemAtom)

	const handleDelete = () => {
		if (!selectedHealing) return

		// Check if it's the temporary item
		if (temporaryItem && selectedHealing.id === temporaryItem.id) {
			clearAiHealingCandidate()
		} else {
			removeHealingItem(selectedHealing)
		}
	}

	return (
		<div aria-label={t("healingContextMenu.ariaHealingContextMenu")}>
			<ContextMenuItem
				trackingLabel="delete_healing"
				aria-label={t("healingContextMenu.ariaDeleteHealingAdjustment")}
				onSelect={handleDelete}
				disabled={!selectedHealing}
			>
				{t("healingContextMenu.delete")}
			</ContextMenuItem>
			<ContextMenuSeparator />
		</div>
	)
}
